import { render, staticRenderFns } from "./ListIbUplevel.vue?vue&type=template&id=255cf69a&scoped=true&"
import script from "./ListIbUplevel.vue?vue&type=script&lang=js&"
export * from "./ListIbUplevel.vue?vue&type=script&lang=js&"
import style0 from "./ListIbUplevel.vue?vue&type=style&index=0&id=255cf69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255cf69a",
  null
  
)

export default component.exports